import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import useMutationWithErrorHandling from '../../data/useMutationWithErrorHandling'
import getPhoenixUrlParams from '../../lib/get-phoenix-url-params'

import {
  BackButtonAbortOrderDocument,
  BackButtonAbortOrderMutation,
  BackButtonAbortOrderMutationVariables,
} from '../../graphql'
import BackButtonComponent from './BackButtonComponent'

interface Props {
  abortOrderOnBackClick?: boolean
}

const BackButton: React.FC<React.PropsWithChildren<Props>> = ({ abortOrderOnBackClick }) => {
  const location = useLocation()
  const history = useHistory()

  const { orderId } = getPhoenixUrlParams(location.search)

  const [abortOrder] = useMutationWithErrorHandling<
    BackButtonAbortOrderMutation,
    BackButtonAbortOrderMutationVariables
  >(BackButtonAbortOrderDocument, { variables: { orderId: orderId as string } })

  const handleClick = () => {
    if (abortOrderOnBackClick) {
      // eslint-disable-next-line  @typescript-eslint/no-floating-promises
      abortOrder()
    }

    history.goBack()
  }

  return <BackButtonComponent onClick={handleClick} />
}

BackButton.defaultProps = {
  abortOrderOnBackClick: false,
}

export default BackButton
